const AUTOPLAY_MS = 7000;

function initHero(root) {
  const slides = [...root.querySelectorAll('.hero__slide')];
  const dots = [...root.querySelectorAll('[data-hero-dot]')];

  if (slides.length < 2) {
    return;
  }

  let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
  let timer = null;
  let paused = false;

  const setActive = (next) => {
    index = (next + slides.length) % slides.length;

    slides.forEach((slide, i) => {
      const active = i === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    dots.forEach((dot, i) => {
      const active = i === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
      dot.tabIndex = active ? 0 : -1;
    });
  };

  const stop = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  const start = () => {
    stop();
    if (paused || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    timer = setInterval(() => setActive(index + 1), AUTOPLAY_MS);
  };

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const next = Number(dot.dataset.heroDot);
      if (Number.isNaN(next)) {
        return;
      }
      setActive(next);
      start();
    });
  });

  root.addEventListener('mouseenter', () => {
    paused = true;
    stop();
  });

  root.addEventListener('mouseleave', () => {
    paused = false;
    start();
  });

  root.addEventListener('focusin', () => {
    paused = true;
    stop();
  });

  root.addEventListener('focusout', (event) => {
    if (!root.contains(event.relatedTarget)) {
      paused = false;
      start();
    }
  });

  root.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      setActive(index + 1);
      start();
    }
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      setActive(index - 1);
      start();
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stop();
    } else if (!paused) {
      start();
    }
  });

  setActive(index);
  start();
}

document.querySelectorAll('[data-hero]').forEach(initHero);
